<template>
  <div>
    <NuxtLoadingIndicator :throttle="0" :color="'#1551B7'" :height="5" />

    <ClientOnly fallbackTag="div">
      <Transition name="fade" appear>
        <main v-if="lifecycleStore.initialized">
          <Notifications />
          <div class="">
            <slot />
          </div>
        </main>
      </Transition>
      <template #fallback>
        <LoadingLayout />
      </template>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const lifecycleStore = useLifecycleStore()
</script>
